import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { environment } from 'environments/environment';
import { GridService } from './grid.service';
import { DrakeCustomScriptsService } from './drake-custom-scripts.service';
import { DrakeSharedService } from './drake-shared.service';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private http: HttpClient, private gridService: GridService, private drakeScripts: DrakeCustomScriptsService, private drakeSharedService: DrakeSharedService) { }


  getFormAutoAction(scopeCode: string): Observable<any> {

    const requestData = {
      ViewCode: "FORMAUTOACTION.DEFAULT",
      Filter: JSON.stringify({ ScopeCode: scopeCode }),
      Sort: JSON.stringify({}),
      Page: 0,
      PageSize: 0,
      Language: "",
      Cache: false,
      ExtraData: {}
    };

    return this.gridService.getScopeData("FORMAUTOACTION", "READ", requestData)
  }

  applyStandardAction(config: any, action: any, property: string, mainRecord: any, user: any) {


    // 🔹 Supporto array diretto OPPURE wrapper { Items: [...] }
    const argsArray =
      Array.isArray(action.Args)
        ? action.Args
        : (Array.isArray(action.Args?.Items) ? action.Args.Items : null);

    if (argsArray) {
      argsArray.forEach((singleArgs: any) => {
        const singleAction = { ...action, Args: singleArgs };
        this.applyStandardAction(config, singleAction, property, mainRecord, user);
      });
      return;
    }
    /*console.log()
    config.pageTabs.forEach(tab => {

      tab.tabComponents.forEach(cmp => {
        var fields = cmp.componentView.viewFields.filter(fld => fld.columnCode == action.Args.Field)

        fields.forEach(fld => {
          fld[property] = eval(action.Args.ValueFormula)
        })
      });
    })*/
    //var conditionReturn = 'ASSIGNED';
    var tempCondition = [];

    //console.log("Inizio funzione applyStandardAction");

    var cmpFields = [];
    config.pageTabs.forEach(tab => {

      tab.tabComponents.forEach(cmp => {
        cmp.componentView?.viewFields.forEach(fld => {
          cmpFields.push(fld);
        });

      });
    });

    if (action.Args.Field === "ALLFORM") {
      /*config.pageTabs.forEach(tab => {

        tab.tabComponents.forEach(cmp => {
          var fields = cmp.componentView.viewFields;

          fields.forEach(fld => {
            if (property === "value") {
              //if(eval(action.Args.ValueFormula) == 'REGISTERED')
              mainRecord[action.Args.Field] = eval(action.Args.ValueFormula);
            }
            else
              fld[property] = eval(action.Args.ValueFormula);
            //fld[property] = eval(action.Args.ValueFormula)
          })
        });
      })*/
      mainRecord['_editable'] = eval(action.Args.ValueFormula);

    }
    if (action.Args.Field === "TRIGGERFIELD" || action.Args.ValueFormula?.includes("TRIGGERFIELD")) {
      //console.log("Trovato 'TRIGGERFIELD' in Args.Field, iterazione su TriggerFields");

      mainRecord['TRIGGERFIELD'] = true;
      var valueTrue = eval(action.Args.ValueFormula);
      mainRecord['TRIGGERFIELD'] = false;
      var valueFalse = eval(action.Args.ValueFormula);
      delete mainRecord.TRIGGERFIELD;
      var matchFieldsAll = [];

      action.TriggerFields.forEach((triggerField: string) => {
        const condition = action.Args.ValueFormula.replace(/TRIGGERFIELD/g, `${triggerField}`);
        //console.log(`Applicazione condizione per TriggerField "${triggerField}": ${condition}`);

        const matchingFields = cmpFields.filter(fld => fld.columnCode === triggerField);//cmp.componentView.viewFields.filter(fld => fld.columnCode === triggerField);

        //if (matchingFields.length === 0) {
        //console.warn(`Nessun campo trovato per "${triggerField}"`);
        //}

        matchingFields.forEach(fld => {
          //console.log(`Applicazione condizione a campo "${fld.columnCode}": ${condition}`);
          tempCondition.push(eval(condition) == valueTrue);
          matchFieldsAll.push(fld);
          //console.log(`Risultato dopo l'applicazione: fld[${property}] = ${fld[property]}`);
        });
      });
      var finalValue = tempCondition.includes(false) ? false : true;

      if (property === "value") {
        //if(eval(condition) == 'REGISTERED')
        //conditionReturn = eval(condition);
        mainRecord[action.Args.Field] = finalValue ? valueTrue : valueFalse;
      }
      else
        matchFieldsAll.forEach(fld => {
          fld[property] = finalValue ? valueTrue : valueFalse;
        });

    }

    else if (action.Args.ComponentId) {
      const components = action.Args.ComponentId.split(";").map(c => c.trim());

      const visibleValue = eval(action.Args.ValueFormula);

      config.pageTabs.forEach(tab => {
        tab.tabComponents.forEach(cmp => {
          if (components.includes(cmp.componentCode)) {
            cmp.componentVisible = visibleValue;
          }
        });
      });

      return;
    }

    else if (action.Args.TargetCollection) {
      const collectionName = action.Args.TargetCollection;
      const collection = mainRecord[collectionName];

      if (Array.isArray(collection)) {
        collection.forEach(component => {
          const conditionResult = eval(action.Args.ValueFormula);

          config.pageTabs.forEach(tab => {
            tab.tabComponents.forEach(cmp => {
              cmp.componentView?.viewFields
                .filter(fld =>
                  fld.columnCode === action.Args.Field &&
                  fld.recordId === component._id
                )
                .forEach(fld => {
                  fld[property] = conditionResult;
                });
            });
          });
        });
      }

      return;
    }


    else {
      //console.log()
      config.pageTabs.forEach(tab => {

        tab.tabComponents.forEach(cmp => {
          var fields = cmp.componentView?.viewFields.filter(fld => fld.columnCode.toUpperCase() == action.Args.Field.toUpperCase())

          fields?.forEach(fld => {
            if (property === "value") {
              //if(eval(action.Args.ValueFormula) == 'REGISTERED')
              mainRecord[action.Args.Field] = eval(action.Args.ValueFormula);
            }
            else
              fld[property] = eval(action.Args.ValueFormula);
            //fld[property] = eval(action.Args.ValueFormula)
          })
        });
      })
    }
    //if(property == 'stato')
    // mainRecord.Stato = conditionReturn;

    //console.log("Fine funzione applyStandardAction");

  }

  applyCustomAction(config: any, action: any, mainRecord: any, user: any) {
    var drakeScripts = this.drakeScripts;
    eval(action.Args.script);
  }

  applyValidation(baseData: any, scope: string, config: any, fieldCode: string | null = null) {

    var invalidFields = [];
    if (config) {
      config.pageTabs.forEach(tab => {

        tab.tabComponents.forEach(cmp => {
          if (cmp.componentView?.viewCode && cmp.componentView.viewCode.split('.')[0] == scope) {
            cmp.componentView?.viewFields.forEach(fld => {
              if (!fieldCode || fieldCode == fld.columnCode) {
                fld.isValid = true;
                var isValid = true;
                isValid = this.validateField(baseData, fld);
                if (!isValid)
                  invalidFields.push(`${tab.tabTitle} > ${cmp.componentName} > ${fld.header}`)

                setTimeout(_ => { fld.isValid = isValid; this.drakeSharedService.baseData$.next({}) }, 10);
              }
            })
          }
        });
      });
      return invalidFields;
    }
    return invalidFields;
  }

  validateField(baseData: any, fld: any) {

    if (this.isEmptyValue(baseData[fld.columnCode]) && fld.fieldValDefault != null) {
      if (fld.fieldValDefault.toLowerCase() == 'false')
        fld.fieldValDefault = false;
      else if (fld.fieldValDefault.toLowerCase() == 'true')
        fld.fieldValDefault = true;
      else if ((fld.fieldDbType == "INT" || fld.fieldDbType == "DECIMAL" || fld.fieldDbType == "FLOAT") && !isNaN(fld.fieldValDefault))
        fld.fieldValDefault = Number(fld.fieldValDefault);
      else if (fld.fieldDbType == "DATE" || fld.fieldDbType == "DATETIME") {
        switch (fld.fieldValDefault.toUpperCase()) {
          case "#NOW#":
            baseData[fld.columnCode] = new Date();
            break;
        }
      }

    }
    if ((fld.required || fld.fieldRequired) && this.isEmptyValue(baseData[fld.columnCode]))
      return false;
    if (fld.validation) {
      switch (fld.validation) {
        case "REGEX":

          let regex = new RegExp(fld.validationParams);
          if (!regex.test(baseData[fld.columnCode]))
            return false;
          break;
        case "RANGE":
          var params = JSON.parse(fld.validationParams);
          if (params.min != undefined && baseData[fld.columnCode] < params.min)
            return false;
          if (params.max != undefined && baseData[fld.columnCode] > params.max)
            return false;
          break;
        case "MATCH":
          var params = fld.validationParams;
          if (baseData[fld.columnCode] != baseData[params])
            return false;
          break;

        case "CAPTCHA":
          if (baseData[fld.columnCode] === null || baseData[fld.columnCode] !== "OK") {
            console.error("Captcha non valido o scaduto");
            return false;
          }
          break;

        case "ISTRUE":
          if (baseData[fld.columnCode] == false)
            return false;

        case "ISFALSE":
          if (baseData[fld.columnCode] == true)
            return false;

      }
    }
    return true;
  }

  isEmptyValue(value: any) {
    return value === '' || value === null || value === undefined;

  }
}
